import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/core/services/base.service';
import { NotesReq, Schedule } from './home';
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { map } from 'rxjs/operators';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { CommonConstants } from 'src/app/common/common.constant';
import { AppConstant, AppMessages, Dashboard, DateFormat, OrderStatusCodes, OrderStatusTypes, Url } from 'src/app/core/constants/app.constant';
import { ConfigureService } from '../configure/configure.service';
import { AccountService } from 'src/app/core/services/account.service';
import { HomeConstants } from './home.constant';
import moment from 'moment-timezone';
import { UtilityService } from 'src/app/core/services/utility.service';
import { UserService } from 'src/app/core/services/user.service';
import { DatePipe } from '@angular/common';
import { ConfigApi, OrderApi, UserApi } from 'src/app/core/constants/api.constant';
import { StaticService } from 'src/app/core/services/static.service';
import { TimeMethodService } from 'src/app/core/utils/time-method.service';
import { ConfigurableFocusTrapFactory } from '@angular/cdk/a11y';
import { PreferenceService } from 'src/app/core/services/preference.service';
import { pharmacyHolidayResponse } from 'src/app/shared/models/app';
import {LocalStorage} from "ngx-webstorage";
import { AbstractControl } from '@angular/forms';


@Injectable({
  providedIn: 'root'
})
export class HomeService extends BaseService {
  /*********************Properties*********************/
  private procedureDataSource = new BehaviorSubject<any>('');
  procedureData = this.procedureDataSource.asObservable();

  monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
  days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  _rejectedRequestCount: any = null;
  _orderTypes: any = null;
  _selectedOrderStatus: any = null;
  _dashboardDate: any = null;
  _orders: any = [];
  _getOrderDefaultDataErrorResponse: any = null;
  _orderTime:any = null;
  _sameDateCutOff = false;
  _sameDateCutOffSupply = false;

  _isLocationWebEnabled = false;
  _isLocationSameDayEnabled = false;
  _locationCutOffStatus: any = null;
  _autoAcceptModifyFlag = false;
  _allergyRequiredFlag = false;

  _isCustomerWebEnabled = false;
  _isCustomerSameDayEnabled = false;
  _sameDayCutOffTime = 0;
  _cancelCutOffTime = 0;

  _productWeekDaysSetting: any = {
    0: { DeliveryFlag: 'sundayDeliveryFlag', SameDayOrderFlag: 'sundaySdoFlag', DayOfWeek: 'Sunday' },
    1: { DeliveryFlag: 'mondayDeliveryFlag', SameDayOrderFlag: 'mondaySdoFlag', DayOfWeek: 'Monday' },
    2: { DeliveryFlag: 'tuesdayDeliveryFlag', SameDayOrderFlag: 'tuesdaySdoFlag', DayOfWeek: 'Tuesday' },
    3: { DeliveryFlag: 'wednesdayDeliveryFlag', SameDayOrderFlag: 'wednesdaySdoFlag', DayOfWeek: 'Wednesday' },
    4: { DeliveryFlag: 'thursdayDeliveryFlag', SameDayOrderFlag: 'thursdaySdoFlag', DayOfWeek: 'Thursday' },
    5: { DeliveryFlag: 'fridayDeliveryFlag', SameDayOrderFlag: 'fridaySdoFlag', DayOfWeek: 'Friday' },
    6: { DeliveryFlag: 'saturdayDeliveryFlag', SameDayOrderFlag: 'saturdaySdoFlag', DayOfWeek: 'Saturday' }
  };

  _cacheNames = {
    customerCatalog: "customerCatalog",
    purchaseOrders: "purchaseOrders",
    orderingPhysicians: "orderingPhysicians",
    customerAdminSettings: "customerAdminSettings",
    productSettings: "productSettings",
    alertCount: "alertCount"
  };
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    protected http: HttpClient,
    private cache: CacheResolverService,
    private staticService: StaticService,
    private utilityService: UtilityService,
    private datePipe: DatePipe,
    private timeMethodService: TimeMethodService,
    private accountService: AccountService,
    private preferenceService: PreferenceService,
  ) {
    super(http);
    this.resetOrderStatus(true);


  }

  changeProcedureData(procedureData: string) {
    this.procedureDataSource.next(procedureData);
  }
  /*********************Constructor*********************/
  /*********************Service Methods*********************/
  /*********************Service Methods*********************/
  /*********************Private Methods*********************/

  getOffsetDate(dateField: any) {
    let timeOffset = (moment(dateField).utcOffset() + new Date(dateField).getTimezoneOffset()) * 60 * 1000;
    let dt = (new Date(dateField)).getTime();
    return moment(dt - timeOffset).format();
  }

  getOffsetMilliDate(dateField: any) {
    let timeOffset = (moment(dateField).utcOffset() + new Date(dateField).getTimezoneOffset()) * 60 * 1000;
    let dt = (new Date(dateField)).getTime();
    return moment(dt + timeOffset).format();
  }
  scheduleBatchOrder(req: Schedule) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.SaveBatchOrder)
    return super.post(url, req);
  }

  saveNotes(req: NotesReq) {
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.SaveNotes)
    return super.post(url, req).pipe(map((response: any) => {
      return response;
    }));
  }

  saveReferringPhysician(reqPayload: any) {
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.ReferringPhysicianSave);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }



  getOrderSearchReport(reqPayload: any) {
    const url = super.serviceUrl(this.apiConfig.order, ConfigApi.OrderSearch);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  removeUnsentOrder(reqPayload: any) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.UnsentOrder);
    return super.delete(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  saveBatchOrder(reqPayload: any) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.SaveBatchOrder);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  // sendOrdersDetail(reqPayload) {
  //   const url = super.serviceUrl(this.apiConfig.order, OrderApi.SendOrders);
  //   return super.post(url, reqPayload).pipe(map((response: any) => {
  //     return response;
  //   }));
  // }

  getDashboardDate() {
    this._dashboardDate.setHours(0);
    this._dashboardDate.setMinutes(0)
    return this._dashboardDate;
  }

  broadcastHeaderDateChange(headerDate: any) {
    this._dashboardDate = new Date(headerDate);
  }

  broadcastDashboardDateChange(dateInterval: any) {
    this._dashboardDate.setDate(this._dashboardDate.getDate() + dateInterval);
  }

  dashboardDetail(reqPayload: any) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.Dashboard);
    return super.post(url, reqPayload).pipe(map((response: any) => {

      return response;
    }));
  }

  checkSlotOrClosestSlot(component: any, timeSlots: any){
    const pref = this.preferenceService.getPreference(AppConstant.Preferences.SYSTEM_TIMEZONE);
    let timezonePref = pref ? pref.value : false;
    let dateEntered = component.componentCalDate+" "+component.componentCalTime;
    let localDateEntered = new Date(dateEntered);
    component.localDate = localDateEntered;
    let selectedDay = null;
    for(let i= 0;i<timeSlots.data.generatorTimeSlotsResponse.length;i++){
      let closestDay = new Date(component.componentCalDate);
      let slotDay = new Date(timeSlots.data.generatorTimeSlotsResponse[i].scheduleDate).setHours(0,0,0,0);
      if(closestDay.getTime() - slotDay == 0){
        selectedDay = timeSlots.data.generatorTimeSlotsResponse[i];
      }
      if(selectedDay != null){
        let minDistance = -1;
        for(let i= 0;i<selectedDay.timeSlotDetails.length;i++){
          let slot = selectedDay.timeSlotDetails[i];
          let distance;
          if(component.dosageAmt && component.dosageAmt <= slot.maxActivity){
            let localOffset = (!timezonePref) ? new Date(slot.externalTimeSlot).getTimezoneOffset()/60 : moment(slot.externalTimeSlot).utcOffset()/60;
            let slotDateTimeLocal = this.convertEpochToLocalTimezone(localOffset, slot.externalTimeSlot,timezonePref);
            let localSlotDate = new Date(slotDateTimeLocal);;
            slot.slotDateString = this.days[localSlotDate.getDay()] + ' ' + this.monthNames[localSlotDate.getMonth()] + ' ' + localSlotDate.getDate() + ', ' + localSlotDate.getFullYear();
            slot.localDateOnly = moment(slotDateTimeLocal).format("MM/DD/YYYY");
            slot.calTimeSlot = moment(slotDateTimeLocal).format("HH:mm");
            let slotDate = new Date(slot.slotDateString + " " + slot.calTimeSlot);
            let time1 = ((slotDate.getHours()*60+slotDate.getMinutes())*60)*1000;
            let time2 = ((localDateEntered.getHours()*60+localDateEntered.getMinutes())*60)*1000;
            distance = Math.abs(time1 - time2);
            if(distance == 0){
              component.selectedSlot = slot;
              component.foundTimeSlot = true;
              component.hasUpdated = true;
              component.closestSlot = null;
              return component;
            } else if(minDistance == -1){
              minDistance = distance;
              component.closestSlot = slot;
            } else if(minDistance > distance){
              minDistance = distance;
              component.closestSlot = slot;
              component.foundTimeSlot = false;
              component.hasUpdated = true;
            }
          }  else {

          }

        }
      }
    }
    return component;
  }

  convertEpochToLocalTimezone(offset: any, epoch: any,timezonePref: any) {
    let localDate = null;
    if (!timezonePref) {
      let date = new Date(epoch);
      let utc = date.getTime() + (date.getTimezoneOffset() * 60000);
      localDate = new Date(utc - (3600000 * offset));
    } else {
      let utc = epoch + (moment(epoch).utcOffset() * 60000);
      localDate = new Date(utc - (3600000 * offset));
    }
    return localDate;
  }

  getTimeslots(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.GetTimeSlots)
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  holdTimeslot(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.HoldTimeSlots)
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  releaseTimeslotRequest(sessionDetails: any) {
    if (sessionDetails && sessionDetails.generatorSlotScheduleXrefDetail) {
      let releaseTimeslotRequest = {
        customerOrderNum: -1,
        generatorSchedulerXrefNum: sessionDetails.generatorSlotScheduleXrefDetail.gnrtrSlotSchedXrefNum,
        gnrtrSlotSchedXrefDtlNum: sessionDetails.generatorSlotScheduleXrefDetail.gnrtrSlotSchedXrefDtlNum,
        sessionNum: sessionDetails.generatorSlotScheduleXrefDetail.sessioNum,
        slotStatus: 13051,
        versionNumXref: sessionDetails.versionXref,
        versionNumXrefDlt: sessionDetails.generatorSlotScheduleXrefDetail.versionNum,
        userId: sessionDetails.generatorSlotScheduleXrefDetail.reservedUserId
      };
      // sessionDetails.isSessionSet = false;
      // component.get('sessionInfo').setValue(sessionDetails);
      return releaseTimeslotRequest;
    }
  }

  releaseTimeslot(reqPayload: any) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.ReleaseTimeSlots)
    return super.post(url, reqPayload).pipe(map((response: any) => {

      return response;
    }));
  }

  checkTimeslotsExpired(batchOrderDetails: { value: any; timeSlots: any; scheduler: any; failedItems?: any; }) {
    var isSlotExpired = false;
    if (batchOrderDetails.value.ga68Flag && batchOrderDetails.value.timeSlots && batchOrderDetails.value.timeSlots.length > 0) {
      batchOrderDetails.timeSlots.forEach((schedule: { sessionInfo: { isSessionSet: any; generatorSlotScheduleXrefDetail: { slotExpStp: any; }; }; scheduleTime: string; }) => {
        if (schedule.sessionInfo && schedule.sessionInfo.isSessionSet) {
          var expirationTime = new Date(batchOrderDetails
            .scheduler
            .convertEpochToLocalTimezone(
              new Date()
                .getTimezoneOffset() / 60,
              schedule.sessionInfo.generatorSlotScheduleXrefDetail.slotExpStp));

          var currentTime = new Date();
          if (currentTime.getTime() > expirationTime.getTime()) {
            isSlotExpired = true;
            batchOrderDetails.failedItems.push(schedule.scheduleTime);
            schedule.scheduleTime = '';
            schedule.sessionInfo = batchOrderDetails.scheduler.resetSessionDetails();
          }
        }
      });
    }
    return isSlotExpired;
  }



  convertDate(timeString: string) {
    var time:any = [];
    time = timeString.split(":");
    var date2 = new Date(this._dashboardDate);
    date2.setHours(time[0]);
    date2.setMinutes(time[1]);
    // if (Date.parse(date2.toUTCString()) < Date.now()) {
    //   // date2.setDate(date2.getDate() + 1);
    // }

    return this.getOffsetDate(date2);//Date.parse(date2.toUTCString());
  }

  specialProducts() {
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.SpecialProducts);
    return super.post(url, {})
  }


  // timeSlots(reqPayload) {
  //   const url = super.serviceUrl(this.apiConfig.order, ConfigApi.TimeSlots)
  //   return super.post(url, reqPayload).pipe(map((response: any) => {
  //     return response;
  //   }));
  // }

  getLinkedOrderDetails(customerShipToNum: number, order: { linkedNum?: any; }) {
    const url = super.serviceUrl(this.apiConfig.order, ConfigApi.linkedDetails)

    // const url = 'https://api.dev.cardinalhealth.com/nphs/wo-order/v1/order/linked/details';
    return super.post(url, {
      customerShipToNum: customerShipToNum,
      linkedNum: order.linkedNum
    })
  }

  getDetails(order: { requestNum?: any; isOrderTypeClick?: any; calibrationStp?: any; orderStatusCode?: any; requestStatusCode?: any; }, customerShipToNum: number, userRole: string) {
    const url = super.serviceUrl(this.apiConfig.order, ConfigApi.details)

    // const url = 'https://api.dev.cardinalhealth.com/nphs/wo-order/v1/order/details';
    return super.post(url, {
      calibrationTime: order.calibrationStp,
      customerShipToNum: customerShipToNum,
      orderStatusCode: order.orderStatusCode,
      requestNum: order.requestNum,
      requestStatusCode: order.requestStatusCode,
      userRole: userRole
    })
  }

  sendOrders(params: object) {
    const url = super.serviceUrl(this.apiConfig.order, ConfigApi.send)
    return super.post(url, params);
  }

  deleteLinkedOrders(requestparams: object | undefined) {
    const url = super.serviceUrl(this.apiConfig.order, ConfigApi.linkedCancel)

    return super.delete(url, requestparams)

  }

  dismissMaintenanceAlert(appMaintenanceNum: string, userDetailNum: number) {
    let dismissObj: any = {
      appMaintenanceNum: appMaintenanceNum,
      userDetailNum: userDetailNum
    }
    dismissObj = JSON.stringify(dismissObj)
    return super.post(this.apiConfig.user + '/appmaintenance/dismiss', dismissObj)
  }

  modify(data: object, order: { isOrderTypeClick?: any; dashboardCountStatusCode?: any; }) {
    let modifyHttpUrl = order.dashboardCountStatusCode === OrderStatusCodes.Unsent ?
      ConfigApi.unsentModify : ConfigApi.Modify;
    const url = super.serviceUrl(this.apiConfig.order, modifyHttpUrl)
    return super.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }

  cancelRemoveOrderItem(requestParams: any) {

    let cancelHttpUrl = requestParams.dashboardCountStatusCode === OrderStatusCodes.Unsent
      ? Url.RemoveOrderUrl : Url.CancelOrderUrl;


    const url = (this.apiConfig.order + cancelHttpUrl);
    return super.delete(url, requestParams)
  }

  sendOrder(data: object) {
    const url = super.serviceUrl(this.apiConfig.order, ConfigApi.send);
    return super.post(url, data);
  }

  isRefPhysicianRqrd(procedureComponents: any[]) {
    return procedureComponents.find((obj: { refPhysicianRqrdFlag: boolean; }) => obj.refPhysicianRqrdFlag === true);
  }

  getLinkedOrderErrorObj(response: { faultInfos: any[]; }, linkedOrders: any[]) {
    let errorResponse = { modalOptions: {}, broadcast: {} };
    let failedOrderInfos = '';

    response.faultInfos.forEach((faultInfos: { faultParamters: { requestNumber: any; }[]; faultMessage: string; }, index: number) => {
      let requestNum = faultInfos.faultParamters[0].requestNumber;
      let linkedOrderDetail = linkedOrders.filter((obj: { requestNum: any; }) => obj.requestNum === requestNum)


      failedOrderInfos += '<p><b>' + (index + 1) + '</b>. ' + linkedOrderDetail[0].calibrationDate + ", " + linkedOrderDetail[0].productName + ", " + faultInfos.faultMessage + "</p>";
    });


    errorResponse.modalOptions = {
      title: 'Linked Orders Status',
      template: '<b>Below orders are not cancelled:</b><br/><br/> {0}'.format(failedOrderInfos),
      showNoButton: false,
      yesButtonText: 'OK',
      isYesPrimary: true
    };

    // errorResponse.broadcast = new BroadcastModel(Constants.Dashboard.Events.LinkedOrderFailed, null);

    return errorResponse;
  }


  calculatePatientBMI(selectedPatientObj: { weightQuantity: any; heightQuantity: any; weightUomCodeObj: any; }) {
    let bmi = 0.0;
    let   height;
    if (!selectedPatientObj.weightQuantity || !selectedPatientObj.heightQuantity) {
      return bmi;
    }
    switch (selectedPatientObj.weightUomCodeObj.value) {
      case CommonConstants.uom.kg:
        height = selectedPatientObj.heightQuantity / 100;
        bmi = selectedPatientObj.weightQuantity / ((height * height));
        break;

      case CommonConstants.uom.pound:
        bmi = 703 * (selectedPatientObj.weightQuantity /
          (selectedPatientObj.heightQuantity * selectedPatientObj.heightQuantity));
        break;

      default:
        break;
    }
    return bmi.toFixed(1);
  }

  getComponentDosageQuantityByType(component: AbstractControl<any, any, any>, patient: { birthDate?: null; lastName?: null; firstName?: null; patientNum?: null; weightQuantity: any; heightQuantity?: null; heightUomCode?: null; weightUomCode?: number | { value: number; } | { value: number; } | { value: number; } | { value: number; } | { value: number; } | { value: number; } | null; weightUomCodeObj?: any; heightUomCodeObj?: any; bmi: any; refPhysicianRqrdFlag?: boolean; mrnId?: null; allergyText?: null; zipCode?: null; dateOfBirth?: null; patientExternalBenefitId?: null; }) {
    let _quantity = component.value.dosageQuantity;
    if (patient &&
      ((component.value.procedureComponentRangeDosings &&
        component.value.procedureComponentRangeDosings.length > 0) ||
        (component.value.procedureComponentWeightDosing))) {
      if (!patient.weightQuantity ||
        patient.weightQuantity <= 0) {
        _quantity = null;
      }
      else {
        switch (component.value.dosingTypeCode) {
          case CommonConstants.variableDosingTypes.bmi:
            if (patient.bmi) {
              _quantity = this.getPatientDosingQuantityByRangeDosing(
                CommonConstants.variableDosingTypes.bmi,
                patient,
                component.value.procedureComponentRangeDosings);
            }
            break;

          case CommonConstants.variableDosingTypes.weightRange:
            if (patient.weightQuantity && patient.weightUomCodeObj.value) {
              _quantity = this.getPatientDosingQuantityByRangeDosing(
                CommonConstants.variableDosingTypes.weightRange,
                patient,
                component.value.procedureComponentRangeDosings);
            }
            break;

          case CommonConstants.variableDosingTypes.weight:
            if (patient.weightQuantity && patient.weightUomCodeObj.value) {
              _quantity = this.getPatientDosingQuantityByWeight(patient, component.value.procedureComponentWeightDosing);
            }
            break;

          default:
            break;
        }
      }
    }
    return _quantity;
  }

  getPatientDosingQuantityByRangeDosing(dosingTypeCode: number, patient: any, rangeDosings: any[]) {
    var quantity = null;
    if (rangeDosings && rangeDosings.length > 0) {
      var valueToCheck = dosingTypeCode === CommonConstants.variableDosingTypes.bmi ?
        Number(patient.bmi) :
        this.getPatientWeightByDosing(patient, rangeDosings[0].weightUomCode);

      var rangeObj = rangeDosings.find(
        (rangeDosage: { rangeStartValue: number; rangeEndValue: number; }) => valueToCheck >= rangeDosage.rangeStartValue &&
          valueToCheck <= rangeDosage.rangeEndValue);


      if (rangeObj) {
        quantity = rangeObj.dosageQuantity;
      } else {
        var maxQuantityObj = rangeDosings
          .find(
            (rangeDosage: { rangeTypeCode: number; }) =>
              rangeDosage.rangeTypeCode ===
              CommonConstants.rangeTypeCodes.greaterThanOrEqualTo);

        quantity = maxQuantityObj &&
          valueToCheck >= maxQuantityObj.rangeStartValue ?
          maxQuantityObj.dosageQuantity : null;
      }
    }

    return quantity ? parseFloat(quantity.toFixed(5)) : null;
  }

  getPatientDosingQuantityByWeight(patient: any, weightDosing: { weightUomCode: any; minimumLimit: any; dosageQuantity: any; maximumLimit?: any; } | null) {
    var quantity = null;
    if (weightDosing) {
      var patientWeight = this.getPatientWeightByDosing(patient, weightDosing.weightUomCode);
      var quantityByWeight = weightDosing.dosageQuantity * patientWeight;

      if (quantityByWeight <= weightDosing.minimumLimit) {
        quantity = weightDosing.minimumLimit;
      } else if (quantityByWeight >= weightDosing.maximumLimit) {
        quantity = weightDosing.maximumLimit;
      } else {
        quantity = quantityByWeight;
      }
    }
    return quantity ? parseFloat(quantity.toFixed(2)) : null;
  }

  getPatientWeightByDosing(patient: { weightUomCodeObj: any; weightQuantity: any; }, dosingWeightUOM: number) {
    var patientWeight = patient.weightQuantity;
    if (patient.weightUomCodeObj.value !== dosingWeightUOM) {
      switch (dosingWeightUOM) {
        case CommonConstants.uom.kg:
          patientWeight = (patientWeight * 0.454);
          break;

        case CommonConstants.uom.pound:
          patientWeight = (patientWeight * 2.205);
          break;

        default:
          break;
      }
    }
    //When we convert weight from lb to kgs or vice versa then also it should round up to one digit after decimal

    patientWeight = parseFloat(patientWeight).toFixed(1);

    return patientWeight;
  }


  saveOrders(selectedOrderType: string, orderObj: any, reservationId: number) {
    var orderSaveObj:any = this.getSaveOrderObj();
    orderSaveObj.cartHeader = this.getOrderHeaderSaveObj(orderObj);
    orderSaveObj.patient =  this.getorderPatientSaveObj(orderObj.patient);
    orderSaveObj.holdTimeSlot = this.getOrderholdTimeSlotObj(selectedOrderType, orderObj);
    orderSaveObj.cartItems = this.getOrderItemsSaveObj(selectedOrderType, orderObj, reservationId);
    orderSaveObj.referringPhysician = !orderObj.referingPhysician ? null : orderObj.referingPhysician.referringPhysicianNum;
    orderSaveObj.referringPhysicianName = !orderObj.referingPhysician ? null : orderObj.referingPhysician.fullName;

    const url = super.serviceUrl(this.apiConfig.order, OrderApi.SaveCart);

    return super.post(url, orderSaveObj).pipe(map((response: any) => {
      return response;
    }));

  }

  private getOrderItemsSaveObj(orderType: any, orderObj: any, reservationId: any) {
    var orderItems: { calibrationTime: any; manualPOFlag: any; componentName?: any; componentNum?: any; dawFlag?: any; dosageQuantity: any; dosageQuantityUomNum: any; indicationTypeCode?: any; noteText: any; orderingPhysicianNum?: any; orderingPhysicianName?: any; particleHigherLimitQuantity?: number | null; particleLowerLimitQuantity?: number | null; patientVisitId?: any; pediatricFlag?: any; productSaleUseNum: any; purchaseOrderId: any; purchaseOrderNum: any; qsVolumeQuantity?: any; clinicalTrialDetail?: { clinicalTrialId: any; protocol: any; studyId: any; subjectId: any; trackingId: any; } | null; reservationId?: any; eligibilityId?: any; supplyFlg?: boolean; }[] = [];
    switch (orderType) {
      case HomeConstants.OrderType.Procedure:
        orderItems = this.getOrderProcedureSaveObj(
          orderObj.procedureComponents,
          orderObj.procedureSupplies,
          reservationId);
        break;

      case HomeConstants.OrderType.Component:
        this.setOrderPONumber(orderObj.procedureComponents);
        orderItems.push(this.getOrderComponentSaveObj(orderObj.procedureComponents, reservationId));
        break;

      case HomeConstants.OrderType.Supply:
        this.setOrderPONumber(orderObj.procedureSupplies);
        orderItems.push(this.getOrderSupplySaveObj(orderObj.procedureSupplies));
        break;

      default:
        break;
    }
    return orderItems;
  }

  private getOrderProcedureSaveObj(procedureComponents: any[], procedureSupplies: any[], reservationId: any) {
    var procedureItems: { calibrationTime: any; manualPOFlag: any; componentName?: any; componentNum?: any; dawFlag?: any; dosageQuantity: any; dosageQuantityUomNum: any; indicationTypeCode?: any; noteText: any; orderingPhysicianNum?: any; orderingPhysicianName?: any; particleHigherLimitQuantity?: number | null; particleLowerLimitQuantity?: number | null; patientVisitId?: any; pediatricFlag?: any; productSaleUseNum: any; purchaseOrderId: any; purchaseOrderNum: any; qsVolumeQuantity?: any; clinicalTrialDetail?: { clinicalTrialId: any; protocol: any; studyId: any; subjectId: any; trackingId: any; } | null; reservationId?: any; eligibilityId?: any; supplyFlg?: boolean; }[] = [];
    procedureComponents.forEach(
      (cmpt: any) => {
        this.setOrderPONumber(cmpt);
        procedureItems.push(this.getOrderComponentSaveObj(cmpt, reservationId));
      });

    procedureSupplies.forEach(
      (supply: any) => {
        this.setOrderPONumber(supply);
        procedureItems.push(this.getOrderSupplySaveObj(supply));
      });
    return procedureItems;
  }

  private setOrderPONumber(orderObj: { manualPOFlag: any; customerPurchaseOrderNum: null; purchaseOrderName: any; customerPurchaseOrderName: any; }) {
    if (orderObj.manualPOFlag) {
      orderObj.customerPurchaseOrderNum = null;
      orderObj.purchaseOrderName = orderObj.customerPurchaseOrderName;
    }
  }

  getOrderholdTimeSlotObj(orderType: string, orderObj: { procedureComponents?: any; }) {
    var sessionInfo: {}[] = [];
    switch (orderType) {
      case HomeConstants.OrderType.Procedure:
        sessionInfo = this.getOrderSessionInfoObj(orderObj.procedureComponents);
        break;

      case HomeConstants.OrderType.Component:
        var tempArray = [];
        tempArray.push(orderObj.procedureComponents);
        sessionInfo = this.getOrderSessionInfoObj(tempArray);
        break;

      case HomeConstants.OrderType.Supply:
        // setOrderPONumber(orderObj.supply);
        // sessionInfo.push(getOrderSupplySaveObj(orderObj.supply));
        break;

      default:
        break;
    }
    return sessionInfo;
  }

  getOrderSessionInfoObj(components: any[]) {
    let retVal: {}[] = [];

    components.forEach(
      (comp: { alternateSchedularProductForm: any; sessionInfo: { generatorSlotScheduleXrefDetail: any; versionXref: any; }; componentNum: any; componentIndex: any; prefferedDateTime: string | number | Date; generatorSlotScheduleXrefDetail: { preferredTimeSlot: any; }; }) => {
        let schedulerInfo = {};
        if (comp.alternateSchedularProductForm && comp.sessionInfo && comp.sessionInfo.generatorSlotScheduleXrefDetail) {
          let timeslotInfo = comp.sessionInfo.generatorSlotScheduleXrefDetail;
          schedulerInfo = {
            generatorSlotScheduleXrefDetail: {
              componentNum: comp.componentNum,
              activity: timeslotInfo.actQty,
              gnrtrSlotSchedXrefDtlNum: timeslotInfo.gnrtrSlotSchedXrefDtlNum,
              gnrtrSlotSchedXrefNum: timeslotInfo.gnrtrSlotSchedXrefNum,
              customerOrderNum: timeslotInfo.customerOrderNum,
              slotStatus: timeslotInfo.slotStatus,
              sessioNum: timeslotInfo.sessioNum,
              blockedAppNum: timeslotInfo.blockedAppNum,
              reservedUserId: timeslotInfo.reservedUserId,
              activeFlag: timeslotInfo.activeFlag,
              deleteFlag: timeslotInfo.deleteFlag,
              versionNum: timeslotInfo.versionNum,
              componentIndex: comp.componentIndex,
              preferredTimeSlot : comp.prefferedDateTime ? new Date(comp.prefferedDateTime).getTime() : (comp.generatorSlotScheduleXrefDetail.preferredTimeSlot?comp.generatorSlotScheduleXrefDetail.preferredTimeSlot:null)
            },
            versionXref: comp.sessionInfo.versionXref
          };
          retVal.push(schedulerInfo);
        }
      });

    return retVal;
  }

  private getSaveOrderObj() {
    return {
      cartHeader: {},
      patient: {},
      referringPhysician: null,
      versionNum: null,
      cartItems: [],
      referringPhysicianName: null,
      holdTimeSlot: []
    };
  }

  private getOrderHeaderSaveObj(orderObj: { procedure: { procedureName: any; procedureNum: any; }; }) {
    let retval = {
      customerShipToNum: this.cache.get(CacheConstant.LocalStorage.ShipTo),
      locationNum: this.cache.get(CacheConstant.LocalStorage.LocationNum),
      procedureName: orderObj.procedure ? orderObj.procedure.procedureName : null,
      procedureNum: orderObj.procedure ? orderObj.procedure.procedureNum : null,
      requestSourceCode: 1
    }
    return retval;
  }

  private getorderPatientSaveObj(patient: { dateOfBirth: any; heightQuantity: any; heightUomCodeObj: { value: any; }; mrnId: any; lastName: string; firstName: string; patientNum: any; weightQuantity: any; weightUomCodeObj: { value: any; }; allergyText: any; zipCode: any; patientExternalBenefitId: any; }) {
    return {
      birthDate:  patient && patient.dateOfBirth ? this.getISODateFormatForBirthDate(this.getOffsetDate(patient.dateOfBirth)) : null,
      height: patient && patient.heightQuantity ? patient.heightQuantity : null,
      heightUom: patient && patient.heightUomCodeObj?.value ? patient.heightUomCodeObj?.value : null,
      mrnId: patient && patient.mrnId ? patient.mrnId : null,
      patientName: patient && patient.lastName &&  patient.firstName ? patient.lastName + ', ' + patient.firstName : patient.lastName ? patient.lastName : patient.firstName ? patient.firstName : null,
      patientNum: patient && patient.patientNum ? patient.patientNum : null,
      weightQuantity: patient && patient.weightQuantity ? patient.weightQuantity : null,
      weightUom: patient && patient.weightUomCodeObj?.value ? patient.weightUomCodeObj?.value : null,
      allergyText: patient && patient.allergyText ? patient.allergyText : null,
      patientFirstNam: patient && patient.firstName ? patient.firstName : null,
      patientLastNam: patient && patient.lastName ? patient.lastName : null,
      patientZipCde: patient && patient.zipCode ? patient.zipCode : null,
      patientExternalBenefitId: patient && patient.patientExternalBenefitId ? patient.patientExternalBenefitId : null,
    }
  }

  private getOrderSupplySaveObj(supply: { calibrationDate: Date; componentCalDate: string | number | Date; componentCalTime: string; productSaleUseNum: any; manualPOFlag: any; supplyAmt: any; uomNum: any; pharmacySupplyNote: any; poNumber: { customerPurchaseOrderNum: any; purchaseOrderName: any; }; customerPurchaseOrderName: any; }) {
    supply.calibrationDate = new Date(moment(this.datePipe.transform(supply.componentCalDate, 'yyyy-MM-dd') + ' ' + supply.componentCalTime).format());

    return {
      productSaleUseNum: supply && supply.productSaleUseNum ? supply.productSaleUseNum : null,
      manualPOFlag: supply && supply.manualPOFlag ? supply.manualPOFlag : null,
      dosageQuantity: supply && supply.supplyAmt ? supply.supplyAmt : null,
      dosageQuantityUomNum: supply && supply.uomNum ? supply.uomNum : null,
      noteText: supply && supply.pharmacySupplyNote ? supply.pharmacySupplyNote : null,
      purchaseOrderNum: supply && supply.manualPOFlag ? null : supply.poNumber?.customerPurchaseOrderNum,
      calibrationTime: supply && supply.calibrationDate ? supply.calibrationDate.getTime() : this._orderTime.getTime(),
      purchaseOrderId: supply && supply.manualPOFlag ? supply.customerPurchaseOrderName : supply.poNumber?.purchaseOrderName,
      supplyFlg:true
    }
  }

  private getOrderComponentSaveObj(component: { calibrationDate: Date; componentCalDate: string | number | Date; componentCalTime: string; manualPOFlag: any; componentName: any; componentNum: any; dawFlag: any; dosageAmt: any; dosageQuantityUomNum: any; indicationTypeCode: any; pharmacyNote: any; orderingPhysician: { orderingPhysicianNum: any; fullName: any; }; particleHigherLimitQuantity: any; particleLowerLimitQuantity: any; patientVisitId: any; pediatricFlag: any; productSaleUseNum: any; customerPurchaseOrderName: any; poNumber: { purchaseOrderName: any; customerPurchaseOrderNum: any; }; qsVolume: any; ctFlag: any; clinicalTrialId: any; protocol: any; studyId: any; subjectId: any; trackingId: any; eligibilityId: any; }, reservationId: any) {
    component.calibrationDate = new Date(moment(this.datePipe.transform(component.componentCalDate, 'yyyy-MM-dd') + ' ' + component.componentCalTime).format());

    return {
      calibrationTime: component && component.calibrationDate ?
        component.calibrationDate.getTime() :
        this._orderTime.getTime(),
      manualPOFlag: component && component.manualPOFlag ? component.manualPOFlag : null,
      componentName: component && component.componentName ? component.componentName : null,
      componentNum: component && component.componentNum ? component.componentNum : null,
      dawFlag: component && component.dawFlag ? component.dawFlag : null,
      dosageQuantity: component && component.dosageAmt ? component.dosageAmt : null,
      dosageQuantityUomNum: component && component.dosageQuantityUomNum ? component.dosageQuantityUomNum : null,
      indicationTypeCode: component && component.indicationTypeCode ? component.indicationTypeCode : null,
      noteText: component && component.pharmacyNote ? component.pharmacyNote : null,
      orderingPhysicianNum: component && component.orderingPhysician ? component.orderingPhysician.orderingPhysicianNum : null,
      orderingPhysicianName: component && component.orderingPhysician ?
        component.orderingPhysician.fullName : null,
      particleHigherLimitQuantity: component && component.particleHigherLimitQuantity ? Number(component.particleHigherLimitQuantity) : null,
      particleLowerLimitQuantity: component && component.particleLowerLimitQuantity ? Number(component.particleLowerLimitQuantity) : null,
      patientVisitId: component && component.patientVisitId ? component.patientVisitId : null,
      pediatricFlag: component && component.pediatricFlag ? component.pediatricFlag : null,
      productSaleUseNum: component && component.productSaleUseNum ? component.productSaleUseNum : null,
      purchaseOrderId: component && component.manualPOFlag ? component.customerPurchaseOrderName : component.poNumber?.purchaseOrderName,
      purchaseOrderNum: component && component.manualPOFlag ? null : component.poNumber?.customerPurchaseOrderNum,
      qsVolumeQuantity: component && component.qsVolume ? component.qsVolume : null,
      clinicalTrialDetail: component && component.ctFlag ?
        {
          clinicalTrialId: component.clinicalTrialId,
          protocol: component.protocol,
          studyId: component.studyId,
          subjectId: component.subjectId,
          trackingId: component.trackingId,
        } : null,
      reservationId: reservationId ? reservationId : null,
      eligibilityId: component.eligibilityId ? component.eligibilityId : null,
      // preferredTimeSlot : component.prefferedDateTime ? new Date(component.prefferedDateTime).getTime() : null
    }
  }

  //New Methods

  getOrderData() {
    return this.cache.get(CacheConstant.LocalStorage.AccountDetails);
  }

  setOrderTime(time: string) {
    return this.setOrderDateTime(time, this._dashboardDate);
  }

  setOrderDateTime(time: string, dashboardDate: any) {
    var hours = time.split(':')[0];
    var minutes = time.split(':')[1];

    const d = new Date(dashboardDate);

    this._orderTime = new Date(
        d.getUTCFullYear(),
        d.getUTCMonth(),
        d.getUTCDate()
    );

    this._orderTime.setHours(hours);
    this._orderTime.setMinutes(minutes);
    this._orderTime.setSeconds('00');
    return this._orderTime;
  }

  getOrderDateTimeObj(time: string) {
    var hoursMinutes = time.split(':');
    var hours: any = hoursMinutes[0];
    var minutes: any = hoursMinutes[1];

    var date = new Date(this._dashboardDate);
    date.setHours(hours);
    date.setMinutes(minutes);
    return date;
  }

  getOrderTypes() {
    return this._orderTypes;
  }

  getSelectedOrderType() {
    var option = null;

    if (this._orderTypes) {
      option = this._orderTypes.procedure.selectedValue != null ? this._orderTypes.procedure
        : (this._orderTypes.component.selectedValue != null ? this._orderTypes.component
          : this._orderTypes.supply);
    }

    return option;
  }

  setOrderType(orderType: { name: any; }) {
    if (!this._orderTypes) {
      this.resetOrderTypes();
    }

    // if (!userService.hasAAARole()) {
    //   this._orderTypes.procedure.selectedValue = null;
    //   this._orderTypes.component.selectedValue = null;
    // }

    this._orderTypes.supply.selectedValue = null;

    this._orderTypes[orderType.name] = orderType;
    this.setOrderTypes(this._orderTypes);
  }

  setOrderTypes(orderTypes: null) {
    this._orderTypes = orderTypes;
  }

  setOrderViewType(viewType: string, userPreferences: { defaultOrderViewNum: {}; } | null) {
    var userDetails = this.cache.get(CacheConstant.LocalStorage.UserDetails);
    if (userPreferences) {
      userDetails.userPreferences = userPreferences;
    }
    userDetails.userPreferences = !userDetails.userPreferences ?
      { userDetailNum: userDetails.userDetailNum, versionNum: 0 } :
      userDetails.userPreferences;
    userDetails.userPreferences.defaultOrderViewNum = viewType;
    this.cache.set(CacheConstant.LocalStorage.UserDetails, userDetails);

    const url = super.serviceUrl(this.apiConfig.user, UserApi.SavePreferences);

    return super.post(url, userDetails.userPreferences);

  }




  getOrderViewType():any {
    var userDetails = this.cache.get(CacheConstant.LocalStorage.UserDetails);
    let defaultOrderViewType = Dashboard.AccountConfigurationTime;
    let preferences;
    if (userDetails) {
      preferences = userDetails.userPreferences;
    }

    if (preferences) {
      defaultOrderViewType = preferences.defaultOrderViewNum;
    }

    // if(userService.getDeviceConfig().deviceType === Constants.App.User.DeviceTypes.Mobile) {
    //   defaultOrderViewType = OrderViewTypes.OrderTimes;
    // }
    return defaultOrderViewType;
  }

  getISODateFormatForBirthDate(date: string | number | Date)
  {
    var dateB = new Date(date);
    dateB.setUTCHours(13,0,0);
    return dateB.toISOString();
  }

  getOrderScheduleByTimeRange(scheduleStartTime: any, scheduleEndTime: any, interval: number | null) {
    interval = interval ? interval : Dashboard.DefautInterval;
    let orderScheduleTimes = [];
    let viewType = this.getOrderViewType();
    scheduleEndTime = scheduleEndTime ? scheduleEndTime : '23:59';

    let _scheduleStartTime = this.getOrderDateTimeObj(scheduleStartTime);
    let _scheduleEndTime = this.getOrderDateTimeObj(scheduleEndTime);

    let orderStartTime = moment(_scheduleStartTime).format('MM/DD/YYYY HH:mm');
    let orderEndTime = moment(_scheduleEndTime).format('MM/DD/YYYY HH:mm');

    /*
    To get order time range based on customer account time zone,
    1) Set schedule start and end time as per customer account time zone
    2) Convert schedule start time into ISO string format and push into array by converting to customer account time zone date.
       If view type is AccountConfigurationTime, then push schedule end time with same formula of schedule start time.
    3) After adding default schedule start and end(optional) time, add interval to schedule start time.
    4) Loop through the time and push date time into array until start time is greater than endt time after adding interval to start time
    */

    /*********Step 1*********/

    scheduleStartTime = _scheduleStartTime.getTime() + (
      (moment(orderStartTime).utcOffset() -
        moment(orderEndTime).utcOffset()) * 6000
    );

    scheduleEndTime = _scheduleEndTime.getTime() + (
      (moment(orderEndTime).utcOffset() -
        moment(orderStartTime).utcOffset()) * 6000
    );

    /*********Step 2*********/
    let utcScheduleStartDate = this.getOffsetDate(scheduleStartTime);// new Date(scheduleStartTime).toISOString()
    orderScheduleTimes.push(new Date(utcScheduleStartDate).getTime());
    // orderScheduleTimes.push(new Date(utcScheduleStartDate).getTime());

    if (viewType === Dashboard.AccountConfigurationTime) {
      let utcScheduleEndDate = this.getOffsetDate(scheduleEndTime);// new Date(scheduleEndTime).toISOString();
      // orderScheduleTimes.push(new Date(utcScheduleEndDate).getTime());
      orderScheduleTimes.push(new Date(utcScheduleEndDate).getTime());

    }
    /*********Step 2*********/

    /*********Step 3*********/
    scheduleStartTime = scheduleStartTime + (interval * 60000);
    /*********Step 3*********/

    /*********Step 4*********/
    while (scheduleStartTime < scheduleEndTime) {
      let utcDate = this.getOffsetDate(scheduleStartTime);//new Date(scheduleStartTime);
      orderScheduleTimes.push(new Date(utcDate).getTime());

      scheduleStartTime = scheduleStartTime + (interval * 60000);
    }
    /*********Step 4*********/

    return orderScheduleTimes;
  }

  resetOrderTypes() { }

  getOrderStatusType() {
    return this._selectedOrderStatus;
  }

  setOrderStatusType(status: number) {
    (this._selectedOrderStatus | status) <= this._selectedOrderStatus ? this._selectedOrderStatus -= status
      : this._selectedOrderStatus += status;
    if (this._selectedOrderStatus <= 0) {
      this.resetOrderStatus(false);
    }

    return this._selectedOrderStatus;
  }

  resetOrderStatus(includeSentOrderStatus: boolean) {
    this._selectedOrderStatus = includeSentOrderStatus ? OrderStatusTypes.Unsent + OrderStatusTypes.Sent
      + OrderStatusTypes.Packaged
      + OrderStatusTypes.Shipped
      + OrderStatusTypes.Cancelled
      : OrderStatusTypes.Unsent;
  }

  getSelectedStatusOrders() {
    let selectedStatusCodeCollection: any = [];
    let selected: any[] = [];

    for (let property in OrderStatusTypes) {

      if (OrderStatusTypes.hasOwnProperty(property) && ((OrderStatusTypes[property] | this._selectedOrderStatus) <= this._selectedOrderStatus)) {
        selectedStatusCodeCollection.push(OrderStatusCodes[property]);
      }
    }
    this._orders?.forEach((order: any) => {
      if ((selectedStatusCodeCollection.indexOf(order.dashboardCountStatusCode) > -1)) {
        selected.push(order);
      }
    })
    return selected;
  }



  getOrderCountByStatus(statusCode: string | number) {
    var count = 0;

    if (this._orders && this._orders.length > 0) {
      this._orders.forEach((obj: any) => {
        let currentStatus = obj.dashboardCountStatusCode;
        if (currentStatus == statusCode) {
          count++;
          // count = currentStatus == statusCode ? count++ : count;
        }
      });
    }

    return count;
  }

  getNotificationDetails(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.RejectNotifications);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  getRejectedNotificationDetails(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.RejectedNotifications);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  dismissMessage(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.DismissNotification);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  sendCreatedOrder(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.SendOrder);
    return super.post(url, reqPayload).pipe(map((response: any) => {

      return response;
    }))
  }

  checkOrderStatus(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.OrderStatus);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }))
  }

  onOrderDataLoaded(data: { customerSetting?: any; locationSetting?: any; }) {
    if (data.customerSetting) {
      this._isCustomerWebEnabled = data.customerSetting.woEnableFlag;
      this._isCustomerSameDayEnabled = data.customerSetting.sdoEnableFlag;
      this._sameDayCutOffTime = data.customerSetting.sameDayLeadQuantity;
      this._cancelCutOffTime = data.customerSetting.cancelLeadQuantity
    }

    if (data.locationSetting) {
      this._isLocationWebEnabled = data.locationSetting.woEnableFlag;
      this._isLocationSameDayEnabled = data.locationSetting.sdoEnableFlag;
      this._locationCutOffStatus = data.locationSetting.cancelCutOffStatusCode;
      this._autoAcceptModifyFlag = data.locationSetting.autoAcceptModifyFlag;
      this._allergyRequiredFlag = data.locationSetting.allergyRequiredFlag;
    }
  }

  validateOrderCalibrationTime(orderDateTime: string | number | Date | null, productSaleUseNum: number | null) {
    // orderDateTime = new Date(orderDateTime);
    //Check if location is web enabled
    if (!this._isLocationWebEnabled) {
      return this.staticService.getMessage(AppConstant.Messages.Orders.PharmacyNotEnabledWebOrdering, '').messageDesc;
    }

    var checkForLocationFlag = true;
    var isSameDay = this.isSameDay(orderDateTime);
    var isSameDayForLocation = this.isSameDay(orderDateTime);

    //Check if customer is web enabled
    if (!this._isCustomerWebEnabled) {
      return this.staticService.getMessage(AppConstant.Messages.Orders.AccountNotEnabledWebOrdering, '').messageDesc;
    }

    //Check if location is same day enabled
    if (isSameDayForLocation && !this._isLocationSameDayEnabled) {
      return this.staticService.getMessage(AppConstant.Messages.Orders.PharmacyNotEnabledSameDayOrdering, '').messageDesc;
    }

    //Check if customer is same day enabled
    if (isSameDay && !this._isCustomerSameDayEnabled) {
      return this.staticService.getMessage(AppConstant.Messages.Orders.AccountNotEnabledSameDayOrdering, '').messageDesc;
    }

    if (this.isPastTime(orderDateTime)) {
      return this.staticService.getMessage(AppConstant.Messages.Orders.PastDateOrder, '').messageDesc;
    }

    // Check if same day cut off is exceeded for the selected time.
    if (this._sameDayCutOffTime && this.isCalTimeExceeded(this._sameDayCutOffTime, orderDateTime)) {
      return this.staticService.getMessage(AppConstant.Messages.Orders.SameDayCutOffExceeded, '').messageDesc;
    }

    if (productSaleUseNum) {
      return this.validateProductForOrder(productSaleUseNum, orderDateTime);
    }

    return null;
  }

  validateProductForOrder(productSaleUseNum: number, calibrationTime: moment.MomentInput) {
    var productSettings = this.getProductSettings(productSaleUseNum).shift();
    let holdidayErrorMessage: string = '';
    if (productSettings && productSaleUseNum && calibrationTime) {
      // calibrationTime = moment(calibrationTime).format();//moment(new Date(calibrationTime)).format(DateFormat.MMDDYYYYHMM);//new Date(calibrationTime).toLocTimezone(DateFormat.);
      holdidayErrorMessage = this.validateHolidayOrder(productSettings,calibrationTime);
      if(holdidayErrorMessage && holdidayErrorMessage.length > 0){
        return holdidayErrorMessage;
      }
      var day = moment(calibrationTime).day();
      var isSameDay = day == new Date(this._dashboardDate).getDay() ? true : false;
      //new Date(calibrationTime).isSameDay();
      var checkForLocationFlag = true;
      var isSameDayForLocation = this.isSameDay(calibrationTime);
      var isNextDayForLocation = this.isNextDay(calibrationTime);
      if (productSettings.leadQuantity && this.isCalTimeExceededForProduct(productSettings.leadQuantity, calibrationTime)) {
        return this.staticService.getMessage(AppConstant.Messages.Orders.ProductSameDayCutOffExceeded, '').messageDesc;
      }

      // Check if product can be deliver for the selected day
      if (productSettings[this._productWeekDaysSetting[day].DeliveryFlag]) {
        //Check if product same day ordering enabled
        if (isSameDayForLocation) {
          if (!productSettings[this._productWeekDaysSetting[day].SameDayOrderFlag]) {
            //Check if same day  is enabled for the product.
            return this.staticService.getMessage(AppConstant.Messages.Orders.ProductNotEnabledSameDayOrdering, '').messageDesc.replace('{0}', this._productWeekDaysSetting[day].DayOfWeek);
          }

        } else if (isNextDayForLocation) {
          //Check for next day cut off. Product should be orderable after the cut off time (next day)
          if (!this.isNextDayProductOrderable(productSettings.nextDayCutOffTime, calibrationTime)) {
            return this.staticService.getMessage(AppConstant.Messages.Orders.ProductNotOrderableAtThisTime, '').messageDesc;
          }
        }
      } else {
        return this.staticService.getMessage(AppConstant.Messages.Orders.ProductNotEnabledWebOrdering, '').messageDesc.replace('{0}', this._productWeekDaysSetting[day].DayOfWeek);
      }
    }
    return null;
  }

  getProductSettings(prodSaleUseNum: number) {
    let productSetting = (this.accountService.getAccountDetailsCacheItem(this._cacheNames.productSettings))?.filter((obj: { productSaleUseNum: number; }) => obj.productSaleUseNum === Number(prodSaleUseNum));
    return productSetting;
  }

  isSameDay(selectedTime: moment.MomentInput) {
    // var today = new Date();
    // let time = this.cache.get(CacheConstant.LocalStorage.CurrentTime).split(' ');
    // today.setHours(time[0].split(':')[0]);
    // today.setMinutes(time[0].split(':')[1]);

    //Check for local date change for product. instead of 23:00 its giving next day
    // var selectedDate = new Date(selectedTime);
    var currentDateFormatted = moment().format('YYYY-MM-DD');
    var selectedDateFormatted = moment(selectedTime).format('YYYY-MM-DD');
    return currentDateFormatted === selectedDateFormatted;
  }

  isNextDay(selectedTime: moment.MomentInput) {
    // var today = new Date(moment().format());

    // let time = this.cache.get(CacheConstant.LocalStorage.CurrentTime).split(' ');
    // today.setHours(time[0].split(':')[0]);
    // today.setMinutes(time[0].split(':')[1]);

    // var tomorrowDate = moment().add(1, 'days').format()//new Date();
    // var selectedDate = new Date(selectedTime);


    var tomorrowDateFormatted = moment().add(1, 'days').format('YYYY-MM-DD')//moment(tomorrowDate).format('YYYY-MM-DD');
    var selectedDateFormatted = moment(selectedTime).format('YYYY-MM-DD');

    return tomorrowDateFormatted === selectedDateFormatted;
  }

  isPastTime(selectedTime: moment.MomentInput) {
    // var selectedDate = new Date(selectedTime);
    // var today = new Date();

    // let time = this.cache.get(CacheConstant.LocalStorage.CurrentTime).split(' ');
    // today.setHours(time[0].split(':')[0]);
    // today.setMinutes(time[0].split(':')[1]);

    var currentDateFormatted = moment().format(DateFormat.MMDDYYYYHMM);// currentdate.toString().toLocalDate(Constants.Format.OrderDefualtDate);
    var selectedDateFormatted = moment(selectedTime).format(DateFormat.MMDDYYYYHMM);//new Date(moment(selectedDate).format(Constants.Format.OrderDefualtDate));
    return new Date(currentDateFormatted).getTime() > new Date(selectedDateFormatted).getTime();
  }

  isCancelCalTimeExceeded(cutOffTimeInMinutes: any) {
    let selectedDateTime = moment().add(cutOffTimeInMinutes, 'minutes').format();//new Date(cutOffTimeInMinutes);
    let currentTime = moment().format(DateFormat.MMDDYYYYHMM)//new Date().toString().toLocalDate();
    // let currentTimeWithCutOff = new Date(new Date(currentTime).getTime() + cutOffTimeInMinutes * 60000);

    return new Date(selectedDateTime).getTime() < new Date(currentTime).getTime();

  };


  isCalTimeExceeded(cutOffTimeInMinutes: any, selectedTime: moment.MomentInput) {
    var selectedDateTime = moment(selectedTime).format(DateFormat.MMDDYYYYHMM);//new Date(selectedTime);

   var currentAccountDateTime = moment().add(cutOffTimeInMinutes,'minutes').format(DateFormat.MMDDYYYYHMM);
    //new Date();
  //  var currentAccountTimeWithCutOff = new Date(currentAccountDateTime).getTime() + (cutOffTimeInMinutes * 60 * 1000);
//const tcal=moment(this.getOffsetDate(currentAccountTimeWithCutOff)).format(DateFormat.MMDDYYYYHMM);

    return new Date(selectedDateTime).getTime() < new Date(currentAccountDateTime).getTime();
  }

  isCalTimeExceededForProduct(cutOffTimeInMinutes: any, selectedTime: moment.MomentInput) {
    var selectedDateTimeInLocation = moment(selectedTime).format(DateFormat.MMDDYYYYHMM);//new Date(this.getOffsetDate(selectedTime));
    var currentDateTimeInLocation = moment().add(cutOffTimeInMinutes, 'minutes').format(); //new Date();
    // var currentLocationTimeWithCutOff = new Date(currentDateTimeInLocation).getTime() + cutOffTimeInMinutes * 60 * 1000;


    return new Date(selectedDateTimeInLocation).getTime() < new Date(currentDateTimeInLocation).getTime();
  }

  isNextDayProductOrderable(nextDaycutOffTime: string, selectedDateTime: moment.MomentInput) {
    var selectedTime = moment(selectedDateTime).format(DateFormat.HHMM);//selectedDateTime1.getHours() + ':' + selectedDateTime1.getMinutes();

    return this.timeMethodService.calculateMinutesBasedOnTime(selectedTime.trim()) >= this.timeMethodService.calculateMinutesBasedOnTime(nextDaycutOffTime.trim());


  }



  getVersionMismatchMessage() {
    var versionMismatchMessage = this.staticService.getMessage(AppMessages.VersionMismatchMessageId, '');
    versionMismatchMessage = versionMismatchMessage ? versionMismatchMessage.messageDesc : 'There is an update available for NPHS Web Ordering. It contains important new features that require an update. It is recommended to run the application with updated features.';

    var template = '<div class="row" class="mg-tp-10"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">'
      + versionMismatchMessage
      + '<h5>Please clear the browser cache and then reload the application.</h5><p class="cache-links-header">Use the links below to clear your existing browser cache.</p></div></div>'
      + '<div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cache-links-items">'
      + '<span><a href="https://support.microsoft.com/en-us/help/17438/windows-internet-explorer-view-delete-browsing-history" target="_blank">Internet Explorer</a></span>'
      + '<span><a href="https://support.mozilla.org/en-US/kb/delete-browsing-search-download-history-firefox" target="_blank">Mozila Firefox</a></span>'
      + '<span><a href="https://support.google.com/chrome/answer/95589?co=GENIE.Platform%3DDesktop&hl=en" target="_blank">Google Chrome</a></span>'
      + '<span><a href="https://support.apple.com/kb/PH21412?locale=en_US" target="_blank">Apple Safari(MAC)</a></span>'
      + '<span><a href="https://support.apple.com/en-us/HT201265" target="_blank">Apple Safari(Mobile/iPad)</a></span></div></div>';

    return template;
  }

  validateOrderTimeSequence(orderItems: any[]) {
    var isValidOrderTimeSequence = true;

    orderItems.forEach((item: { value: { componentCalDate: string | number | Date; }; }, index: number) => {
      if (index > 0) {
        var currentCalibrationTime = new Date(item.value.componentCalDate);
        var previousCalibrationTime = new Date(orderItems[index - 1].value.componentCalDate);

        if (previousCalibrationTime > currentCalibrationTime && previousCalibrationTime !== currentCalibrationTime) {
          isValidOrderTimeSequence = false;
        }
      }
    });

    return isValidOrderTimeSequence;
  }

  isCustomerSameDayEnabled(orderDateTime: Date | null) {
    //Check if customer is same day enabled
    var isSameDayForLocation = this.isSameDay(orderDateTime);

    if (isSameDayForLocation && !this._isCustomerSameDayEnabled) {
      return this.staticService.getMessage(AppConstant.Messages.Orders.AccountNotEnabledSameDayOrdering, '').messageDesc;
    }

    return null;
  }

  saveReturnDetails(reqPayload: object)
  {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.SaveInvoiceReturnUrl)
    return super.post(url, reqPayload);
  }

  validateProductValidations(prodValidations: any[], productSaleUseNum: number) {
    return prodValidations?.find((prod: { prodSaleUseNum: any; ctFlag: string; }) => prod.prodSaleUseNum == productSaleUseNum && prod.ctFlag == 'N');
  }

  validateIfProductIsEligibleForPatientBenefit(prodValidations: any[], productSaleUseNum: number) {
    return prodValidations?.find((prod: { prodSaleUseNum: any; isEnablePatientBenefitEligibility: string; }) => prod.prodSaleUseNum == productSaleUseNum && prod.isEnablePatientBenefitEligibility == 'Y');
  }

  validateIfProductIsCapacityPlanningRequired(prodValidations: any[], productSaleUseNum: any) {
    return prodValidations?.find(prod => prod.prodSaleUseNum == productSaleUseNum && prod.isCapacityPlanningRequired == 'Y');
  }

  /*********************Private Methods*********************/

  trackAbandonTimeSlot(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.AbandonTimeSlots)
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  getDateAccNumber() {
    const date = this._dashboardDate;
    const onlyDate = moment(date).format(DateFormat.YYYYMMDD);
    const isPastDate = moment(onlyDate).isBefore(moment().format(DateFormat.YYYYMMDD),'day');
    let utcDate = null;
    const eodTimeforPastDate = "23:59:59";

    if(isPastDate){
       utcDate = moment(onlyDate + " " + eodTimeforPastDate).format(DateFormat.YYYYMMDDTHHMMSS);
    }
    else{
      utcDate = moment(onlyDate).endOf('day').utc().format();
    }

    const data = {
      date: utcDate,
      customerShipToNum: this.cache.get(CacheConstant.LocalStorage.ShipTo),
    }
    return data;
  }

  getNewRejectNotificationPreference(){
    let RejectNotificationModuleFlag = this.staticService.getApplicationPreference(AppConstant.Preferences.NEW_REJECT_NOTIFICATION_MODULE_FLAG);
   let showNewRejectNotification =  RejectNotificationModuleFlag && (RejectNotificationModuleFlag.preferenceValue == 'Y');
   return showNewRejectNotification;
  }

  acknowledgeRejectNotification(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.acknowledgeRejectNotification);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  getLocationHolidayDates(locationNumber: Number,currentDate: String,nextYearDate: String): Observable<pharmacyHolidayResponse[]> {
    let requestPyaload ={currentDate:currentDate,nextYearDate:nextYearDate};
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.getLocationHolidayDates)+'/'+locationNumber;
    return super.post(url,requestPyaload).pipe(map((response: any) => {return response.data}));
  }
  checkManufacturerOrder(materialId: any ): boolean{
    if ( this.cache.get(CacheConstant.LocalStorage.nonOrderableMaterialIds) &&  this.cache.get(CacheConstant.LocalStorage.nonOrderableMaterialIds).length > 0) {
      if ( this.cache.get(CacheConstant.LocalStorage.nonOrderableMaterialIds).includes(materialId) ) {
        return true
      }
    }
    return false
  }
  checkReturnInventoryExclusion(materialId: any ): boolean{
    if ( this.cache.get(CacheConstant.LocalStorage.nonReturnableMaterialIds) &&  this.cache.get(CacheConstant.LocalStorage.nonReturnableMaterialIds).length > 0) {
      if ( this.cache.get(CacheConstant.LocalStorage.nonReturnableMaterialIds).includes(materialId) ) {
        return true
      }
    }
    return false
  }


  validateHolidayOrder(productSettings: { holidaySdoFlag: any; holidayDeliveryFlag: any; },calibrationTime: moment.MomentInput) : string{
    let locationCalendar: pharmacyHolidayResponse[] = this.cache.get(CacheConstant.LocalStorage.PhamacyHolidayList);
    let selectedDateFormatted = moment(calibrationTime).format('MM-DD-YYYY');
    let pharmacyHolidayError: string = '';
    if(locationCalendar && locationCalendar.length > 0){
      locationCalendar.forEach((location: pharmacyHolidayResponse) => {
        if(location.holidayDate === selectedDateFormatted  && location.activeFlag == true) {
          if(this.isSameDay(calibrationTime)){
            if(productSettings.holidaySdoFlag){
              if(!productSettings.holidayDeliveryFlag){
                pharmacyHolidayError = this.staticService.getMessage(AppConstant.Messages.Orders.PharmacyHoldiday, '').messageDesc;
              }
            }
          } else if(!productSettings.holidayDeliveryFlag){
            pharmacyHolidayError = this.staticService.getMessage(AppConstant.Messages.Orders.PharmacyHoldiday, '').messageDesc;
          }
        }
      })
    }

    return pharmacyHolidayError;
  }

  isPluvicto(materialIds: string | any[]){
    let isPluvictoOrder = false;
     let pluvictoIDs = []
    if(materialIds?.length > 0){
      pluvictoIDs= this.cache.get(CacheConstant.LocalStorage.nonOrderableMaterialIds);
      if(pluvictoIDs && pluvictoIDs.length > 0){
        for(let pluvictoID of pluvictoIDs){
        isPluvictoOrder = materialIds.includes(pluvictoID);
        if(isPluvictoOrder){
          return isPluvictoOrder
        }
      }
    }
    return isPluvictoOrder;
  }}

   getPatients(reqPayload: object) {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.getPatients)
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

   getSonexusEnrollmentURL() {
    const url = super.serviceUrl(this.apiConfig.order, OrderApi.getSonexusEnrollmentURL);
    return super.post(url, {}).pipe(map((response: any) => {
      return response;
    }));
  }

}
